import Home from "pages/Home/Home"
import UpdateBanner from "features/UpdateBanner/UpdateBanner"
import "shared/scss/global.scss"

function App() {
  return (
    <>
      <Home />
      <UpdateBanner />
    </>
  )
}

export default App
